/**
 * German, user-facing labels for the technical QL-Widget-Builder mapping keys
 * (`UiQlWidgetTypeRegistryEntry.requiredMappingKeys` / `UiQlWidgetChartMappingDto` /
 * `UiQlWidgetCategoryMappingDto`, e.g. `chartField1st`, `fieldCategory`) — used wherever a mapping
 * violation names such a key, so the user sees a label ("Achsenfeld") instead of the raw technical
 * key ("chartField1st"). Deliberately its own module (no Angular dependency) so both
 * `UiQlWidgetDataBuilder` (missing-mapping message) and the widget-type editor component can share
 * it without drifting apart.
 */
export const UI_QL_WIDGET_MAPPING_KEY_LABELS: Readonly<Record<string, string>> = {
    chartType: 'Diagrammart',
    chartField1st: 'Achsenfeld',
    chartFieldAggregate: 'Wertfeld',
    chartAggregateFunction: 'Aggregatfunktion',
    chartField2nd: 'Zweites Achsenfeld',
    fieldCategory: 'Kategorie-Feld',
    fieldCategoryCount: 'Anzahl-Feld',
    displayMode: 'Darstellung',
};

/**
 * AI:
 * Status: "in progress"
 * Type: Logic
 * SubType: Mapping
 * Reason: Translates a QL-Widget-Builder mapping key to its German, user-facing label for
 *   violation/help texts — falls back to the raw key when no label is defined.
 */
export class UiQlWidgetMappingKeyLabels {

    static label(key: string): string {
        return UI_QL_WIDGET_MAPPING_KEY_LABELS[key] ?? key;
    }
}
